export const trackClick = (location) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track-click`;
    const body = JSON.stringify({ location });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, {
        method: "POST",
        body,
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      });
    }
  } catch (e) {
    // tracking must never block navigation
  }
};

export const WA_MESSAGE = encodeURIComponent(
  "Olá, Vanessa! Vim pelo seu site e gostaria de agendar uma sessão."
);

export const WHATSAPP_URL = `https://wa.me/5517991356298?text=${WA_MESSAGE}`;

export const scrollToId = (id) => {
  const target = document.querySelector(id);
  if (!target) return;
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(target, { offset: -72, duration: 1.4 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const IMAGES = {
  hero: "/images/vanessa-hero.webp",
  manifesto: "/images/vanessa-pc.webp",
  portrait: "/images/vanessa-sobre.webp",
};
